export default __webpack_public_path__ + "static/media/Kaggen_glad.d9624300.jpg";